import type { AthenaEvent } from "@evidenceb/athena-event-storage-schemas";
import { useContext, useEffect } from "react";
import { v4 as uuid } from "uuid";
import { useInitializingEventStream } from "../contexts/EventStreamContext";
import { sessionStore } from "../contexts/SessionContext";
import { useSessionGuard } from "../contexts/SessionGuardProvider";
import useOnlineStatus from "./useOnlineStatus";
import { useUserId } from "./useUserInfo";

export const usePingEvent = () => {
  const {
    session: { sessionId, version },
  } = useContext(sessionStore);
  const isOnline = useOnlineStatus();
  const userId = useUserId();
  const athenaEventStream = useInitializingEventStream();
  const { isBlocked } = useSessionGuard();
  useEffect(() => {
    // Stop ping if not logged in or user is idle/stale session.
    if (!athenaEventStream || !userId || isBlocked()) {
      return;
    }
    const id = setInterval(() => {
      const event: AthenaEvent<"session", "SessionPingEvent"> = {
        id: uuid(),
        createdAt: new Date().toISOString(),
        userId: userId,
        sessionId: sessionId,
        app: version,
        categoryData: {
          online: isOnline,
        },
        type: "SessionPingEvent",
        data: {
          url: window.location.href.split("?")[0],
        },
      };
      athenaEventStream.publish(event);
    }, 30_000);
    return () => {
      clearInterval(id);
    };
  }, [athenaEventStream, userId, sessionId, isOnline, version, isBlocked]);
};
